module.exports = __webpack_public_path__ + "static/media/julia.04f56b78.jpg";